/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ShipmentLabelRequest = {
    name: string;
    /**
     * purple | blue | green | orange | red | gray
     */
    color: ShipmentLabelRequest.color;
};
export namespace ShipmentLabelRequest {
    /**
     * purple | blue | green | orange | red | gray
     */
    export enum color {
        PURPLE = 'purple',
        BLUE = 'blue',
        GREEN = 'green',
        ORANGE = 'orange',
        RED = 'red',
        GRAY = 'gray',
    }
}

